{
    "Section_Header": "Enviar para mim e:",
    "Section_SubHeader": "Outros destinatários:",
    "Validation_Valid_Domain_Name": "O e-mail deve ser válido.",
    "Validation_Valid_Same_As_User": "O e-mail deve pertencer ao mesmo domínio do utilizador atual.",
    "Validation_Valid_Non_Blacklisted_Email": "O e-mail não deve pertencer a um domínio bloqueado.",
    "Validation_Valid_Max_Custom_Domains": "Apenas pode adicionar um máximo de {} e-mails personalizados.",
    "Validation_Valid_Max_Entries": "Não pode ter mais de {} e-mails",
    "NAME": "ReportSchedulingEmails"
}